import React, { Fragment } from 'react';
import { Link } from 'react-router-dom';
import PropTypes from 'prop-types';
import styled, { css } from 'styled-components';
import FinautaWhiteLogo from '../../images/svgs/finauta/logo-white.svg';
import { mp, getCampaign } from '../../constants/utils';
import { FlowHeader } from '../GoalsFlow/styles';
import ReactFullpage from '@fullpage/react-fullpage';
import FullscreenSection from '../shared/FullscreenSection';
import Graphic from '../landing/Graphic';

import Logo from '../shared/Logo';
import { WhiteLogo } from './resultsStyles';
import { flexCenter, flexColumn } from '../../constants/styles';
import Text from './Text';
import OptionCard from './OptionCard';
import SimpleQA from './SimpleQA';
import PoliglotLink from '../PoliglotLink';
import { poliglotLink } from '../../classes/poliglotlink';

const StyledFishingGraphic = css`
  align-self: center;
  width: 85%;
  max-width: 350px;
  margin-top: 2em;
`;

const StyledOnlyTextSection = styled.div`
  ${flexColumn}
  ${flexCenter}
`;

const FishingMobile = 'https://s3.us-east-2.amazonaws.com/finauta/art/fishingMobile.png';
const FishingDesktop = 'https://s3.us-east-2.amazonaws.com/finauta/art/fishing.png';

const MasterFullpageResult = ({ children, onSlideChange, supuestos, faqs, anchors = [] }) => (
  <ReactFullpage
    licenseKey="B7D09353-77774B0B-A27E0823-888F7309"
    scrollingSpeed={1000} /* Options here */
    normalScrollElements=".option-content, .scrollable-qas"
    onLeave={(origin, destination, direction) => {
      onSlideChange(destination.index);
      if (destination.index < children.length && children[destination.index]) {
        mp(
          `[${getCampaign(window.location.href)}] | Retiro | Results | ${
            children[destination.index].props.identifier
          }`,
        );
      } else if (children[destination.index]) {
        mp(`[${getCampaign(window.location.href)}] | Retiro | Results | AboutFinauta`);
      }
    }}
    render={({ state, fullpageApi }) => (
      <ReactFullpage.Wrapper>
        <FlowHeader>
          <PoliglotLink to={new poliglotLink('https://www.finauta.com')}>
            <WhiteLogo src={FinautaWhiteLogo} id="logo" />
          </PoliglotLink>
        </FlowHeader>
        {children.map((section, idx) => {
          if (section) {
            const { showTeaser, teaserText, identifier, alignTop, smallTeaser } = section.props;
            return (
              section && (
                <FullscreenSection
                  smallTeaser={smallTeaser}
                  key={`fp-${identifier}`}
                  alignTop={alignTop}
                  identifier={identifier}
                  showTeaser={showTeaser}
                  teaserText={teaserText}
                  teaserFunction={() => fullpageApi.moveSectionDown()}
                >
                  {section}
                </FullscreenSection>
              )
            );
          } else {
            return null;
          }
        })}
        <FullscreenSection alignTop key="MoreAboutFinauta" identifier="MoreAboutFinauta">
          <StyledOnlyTextSection>
            <Logo position="unset" style={{ marginBottom: '1em' }} />
            <Text
              type="reference1"
              style={{ marginBottom: '1em', marginTop: '1em', maxWidth: '450px' }}
            >
              Finauta es una empresa mexicana que tiene como fin ayudarte a lograr tus metas
              financieras.
            </Text>
            <Text type="reference1" style={{ marginBottom: '1em', maxWidth: '450px' }}>
              Por medio de herramientas financieras amigables y expertos certificados, simplificamos
              las finanzas personales para que tú puedas lograr tus sueños.
            </Text>
            {supuestos && (
              <OptionCard
                title="Supuestos"
                subtitle={<div></div>}
                styles={css`
                  width: 100%;
                  max-width: 450px;
                  margin-bottom: 6px;
                  margin-top: 20px;
                `}
                small
              >
                <Fragment>
                  {supuestos.map((QA) => (
                    <SimpleQA
                      question={QA.question}
                      answer={QA.answer}
                      key={`supuesto-${QA.title}`}
                    />
                  ))}
                </Fragment>
              </OptionCard>
            )}
            {faqs && (
              <OptionCard
                title="¿Dudas?"
                subtitle={<div></div>}
                styles={css`
                  width: 100%;
                  max-width: 450px;
                `}
                small
              >
                <Fragment>
                  {faqs.map((QA) => (
                    <SimpleQA question={QA.question} answer={QA.answer} key={`faq-${QA.title}`} />
                  ))}
                </Fragment>
              </OptionCard>
            )}
          </StyledOnlyTextSection>
        </FullscreenSection>
      </ReactFullpage.Wrapper>
    )}
  />
);

MasterFullpageResult.propTypes = {
  changingNumber: PropTypes.string,
  minusFunction: PropTypes.func,
  plusFunction: PropTypes.func,
};

MasterFullpageResult.defaultProps = {
  changingNumber: '',
  minusFunction: () => {},
  plusFunction: () => {},
};

export default MasterFullpageResult;
